import { useEffect, useState } from 'react';
import axios from '../utils/axiosConfig';

const useAchievementConfig = () => {
  const [achievementConfigs, setAchievementConfigs] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAchievementConfigs = async () => {
      try {
        const response = await axios.get('/api/v1/achievement/definitions');

        // Transform the array into an object keyed by achievement type
        const configMap = response.data.definitions.reduce((acc, achievement) => {
          acc[achievement.type] = {
            id: achievement.achievement_id,
            name: achievement.name,
            description: achievement.description,
            imageUrl: achievement.image_url,
          };
          return acc;
        }, {});

        setAchievementConfigs(configMap);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.detail || err.message);
        setLoading(false);
      }
    };

    fetchAchievementConfigs();
  }, []);

  return { achievementConfigs, loading, error };
};

export default useAchievementConfig;
